<template>
  <!--  <div class="content receipts">
    <div class="heading">
      <h2 class="page-title">
        {{ label.get('subscription_receipts') }}
      </h2>
    </div>
    <div class="list-container">
      <div class="table-heading">
        <span class="heading-label date">{{ label.get('date') }}</span>
        <span class="heading-label desc">{{ label.get('description') }}</span>
        <span class="heading-label sm">{{ label.get('charge') }}</span>
        <span class="heading-label sm">{{ label.get('status') }}</span>
        <span class="heading-label btn" />
      </div>
      <ul class="receipts">
        <li
          v-for="(item, idx) in receipts"
          :key="idx"
        >
          <h4 class="date">
            {{ item.date }}
          </h4>
          <p class="desc">
            {{ item.description }}
          </p>
          <span class="charge">{{ item.total }}</span>
          <span class="status">{{ item.paid }}</span>
          <div class="options">
            <button
              class="download-receipt"
              @click="downloadReceipt(item.local_invoice.token_number)"
            >
              <i class="atto atto-download" />
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>-->

  <div id="receipts-section">
    <div class="centered-column" v-if="loaded">
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{
              label.get("subscription_receipts")
            }}</label>
          </div>
        </div>
        <div class="receipts">
          <div class="list-container">
            <div class="table-heading">
              <span class="heading-label date">{{ label.get("date") }}</span>
              <span class="heading-label desc">{{
                label.get("description")
              }}</span>
              <span class="heading-label sm">{{ label.get("charge") }}</span>
              <span class="heading-label sm">{{ label.get("status") }}</span>
              <span class="heading-label btn" />
            </div>
            <ul class="receipts">
              <li v-for="(item, idx) in receipts" :key="idx">
                <h4 class="date">
                  <i class="atto atto-subscription-card setting-icon" />
                  {{ item.date }}
                </h4>
                <p class="desc">
                  {{ item.description }}
                </p>
                <span class="charge">${{ item.total }}</span>
                <span class="status">{{ item.paid }}</span>
                <div class="options">
                  <button
                    class="download-receipt"
                    @click="downloadReceipt(item.local_invoice.token_number)"
                  >
                    <i class="atto atto-download" />
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BillingService from "../services/BillingService";

export default {
  name: "BillingReceiptsComponent",
  data() {
    return {
      loaded: false,
      receipts: [],
    };
  },
  created() {
    this.getReceipts();
  },
  methods: {
    getReceipts() {
      BillingService.getReceipts()
        .then((result) => {
          this.receipts = result.receipts;
          this.loaded = true;
        })
        .catch((error) => {});
    },
    downloadReceipt(token) {
      this.$store.commit("showLoading");
      BillingService.downloadReceipt(token)
        .then((response) => {
          let filename = "";
          const disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches !== null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(response.data, filename);
          } else {
            const a = document.createElement("a");
            a.href = window.URL.createObjectURL(response.data);
            a.download = filename;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
          }
          this.$store.commit("hideLoading");
        })
        .catch(() => {
          this.$store.commit("hideLoading");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* @media queries */
@mixin mobile {
  @media (max-width: 480px) {
    @content;
  }
}
/* End of: @media queries */

#receipts-section {
  @include mobile {
    display: none;
  }
}

.receipts {
  padding: 0;

  .heading {
    display: flex;
    flex-direction: row;
    padding: 28px 80px 29px;
    border-bottom: 0;
  }

  .list-container {
    .table-heading {
      padding: 12px 16px 12px 64px;
      background: #fafafa;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 35px;
      align-items: center;

      span.heading-label {
        display: inline-flex;
        color: #666666;
        font: $roboto-medium 0.625rem/0.6875rem $roboto-font;
        text-transform: uppercase;
        border: none;
        letter-spacing: 0.5px;
        margin: 0;

        &.date {
          width: 200px;
        }

        &.desc {
          width: 345px;
        }

        &.sm {
          width: 100px;
        }

        &.btn {
          width: 40px;
        }
      }
    }

    ul.receipts {
      display: flex;
      flex-direction: column;

      li {
        display: flex;
        flex-direction: row;
        padding: 13px 8px 13px 20px;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        @include base-transition(ease all 0.15s);

        p {
          margin-bottom: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
        }

        h4.date {
          color: #262626;
          font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
          width: 240px;
          display: flex;

          i {
            margin-right: 20px;
            font-size: 0.875rem;
          }
        }

        p.desc {
          color: $atto-font-color;
          font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
          width: 343px;
        }

        span {
          color: $atto-font-color;
          font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
          width: 100px;
        }

        .options {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 0;
        }

        button {
          width: 40px;
          height: 40px;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          @include base-transition(ease all 0.15s);

          i {
            padding: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            font-size: 16px;
            color: #999;
            @include base-transition(ease all 0.15s);
            margin: 0;
          }

          &:hover {
            background-color: #efefef;

            i {
              color: #262626;
            }
          }
        }

        &:hover {
          background-color: #fafafa;
        }

        &:last-child {
          border-bottom: 0;
        }
      }
    }
  }
}
@media (max-width: 1110px) {
  .receipts {
    .list-container {
      .table-heading {
        span.heading-label.date {
          width: 140px;
        }
      }
      ul.receipts li h4.date {
        width: 200px;
      }
    }
  }
}
</style>
